import { Action } from '@ngrx/store'
import * as UnitsSettingsTypes from './units-settings.types'

export class FetchUnitsSettingsRequest implements Action {
  readonly type = UnitsSettingsTypes.FETCH_UNITS_SETTINGS_REQUEST
  constructor() {}
}

export class FetchUnitsSettingsSuccess implements Action {
  readonly type = UnitsSettingsTypes.FETCH_UNITS_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchUnitsSettingsFailure implements Action {
  readonly type = UnitsSettingsTypes.FETCH_UNITS_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateUnitsSettingsRequest implements Action {
  readonly type = UnitsSettingsTypes.UPDATE_UNITS_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateUnitsSettingsSuccess implements Action {
  readonly type = UnitsSettingsTypes.UPDATE_UNITS_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateUnitsSettingsFailure implements Action {
  readonly type = UnitsSettingsTypes.UPDATE_UNITS_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = UnitsSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = UnitsSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchUnitsSettingsSuccess
  | FetchUnitsSettingsFailure
  | FetchUnitsSettingsRequest
  | UpdateUnitsSettingsRequest
  | UpdateUnitsSettingsSuccess
  | UpdateUnitsSettingsFailure
  | SetDefaultData
  | UpdateField
